export default __webpack_public_path__ + "static/media/challenge-complete.11c95c9b.svg";